import { Link } from 'react-router-dom'
import { Icon, Typography } from 'src/modules/core/components'
import type { LateCancelsEmptyState as EmptyStateKind } from '../../utils/late-cancel-display.util'
import type { LateCancelsEmptyStateCopy, LateCancelsEmptyStateProps } from './late-cancels-empty-state.interface'
import classes from './late-cancels-empty-state.module.scss'

const COPY: Record<EmptyStateKind, LateCancelsEmptyStateCopy> = {
  turn_on: {
    title: 'Your cancellation policy is off',
    body: 'Turn it on to warn clients who cancel inside your notice window. Their late cancels will show up here so you can charge a fee or follow up.',
    linkLabel: 'Turn on your cancellation policy',
  },
  none_yet: {
    title: 'No late cancels yet',
    body: "When a client cancels inside your cancellation window, they'll show up here with the details you need to charge a fee or follow up.",
    linkLabel: 'Review your cancellation policy',
  },
  all_caught_up: {
    title: 'All caught up',
    body: 'Every late cancel has been resolved. You can find them under Resolved.',
  },
  none_resolved: {
    title: 'Nothing resolved yet',
    body: 'Late cancels you mark resolved will show up here.',
  },
}

export function LateCancelsEmptyState({ kind, settingsPath }: LateCancelsEmptyStateProps) {
  const copy = COPY[kind]
  return (
    <div className={classes.root} data-testid={`late-cancels-empty-${kind}`}>
      <Icon name="lateCancels" className={classes.icon} aria-hidden="true" />
      <Typography variant="h4" className={classes.title}>
        {copy.title}
      </Typography>
      <Typography variant="body" className={classes.body}>
        {copy.body}
      </Typography>
      {copy.linkLabel && (
        <Link to={settingsPath} className={classes.link}>
          {copy.linkLabel} <span aria-hidden="true">→</span>
        </Link>
      )}
    </div>
  )
}
